export class ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner {
    'name';
    'location';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureUnassignedNetworkInterfaces200ResponseNetworkInterfacesInner.attributeTypeMap;
    }
    constructor() {
    }
}
